function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); Object.defineProperty(subClass, "prototype", { writable: false }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

/** @jsx h */
import { h } from 'preact';
import { UIPlugin } from '@uppy/core';
import './style.scss';

var LoadingStatus = /*#__PURE__*/function (_UIPlugin) {
  _inherits(LoadingStatus, _UIPlugin);

  var _super = _createSuper(LoadingStatus);

  function LoadingStatus(uppy, opts) {
    var _this;

    _classCallCheck(this, LoadingStatus);

    _this = _super.call(this, uppy, opts);
    _this.id = _this.opts.id || 'LoadingStatus';
    _this.type = 'progressindicator';
    _this.render = _this.render.bind(_assertThisInitialized(_this));
    _this.install = _this.install.bind(_assertThisInitialized(_this));
    _this.show = _this.show.bind(_assertThisInitialized(_this));
    _this.hide = _this.hide.bind(_assertThisInitialized(_this));
    return _this;
  }

  _createClass(LoadingStatus, [{
    key: "show",
    value: function show() {
      var _this$parent, _this$parent$disableA;

      (_this$parent = this.parent) === null || _this$parent === void 0 ? void 0 : (_this$parent$disableA = _this$parent.disableAllFocusableElements) === null || _this$parent$disableA === void 0 ? void 0 : _this$parent$disableA.call(_this$parent, true);
      this.setPluginState({
        isLoading: true
      });
    }
  }, {
    key: "hide",
    value: function hide() {
      var _this$parent2, _this$parent2$disable;

      (_this$parent2 = this.parent) === null || _this$parent2 === void 0 ? void 0 : (_this$parent2$disable = _this$parent2.disableAllFocusableElements) === null || _this$parent2$disable === void 0 ? void 0 : _this$parent2$disable.call(_this$parent2, false);
      this.setPluginState({
        isLoading: false
      });
    }
  }, {
    key: "render",
    value: function render() {
      var _this$getPluginState = this.getPluginState(),
          isLoading = _this$getPluginState.isLoading;

      var activeClassName = isLoading ? 'kj-uploader-LoadingStatus--is-loading' : '';
      return h("div", {
        className: "kj-uploader-LoadingStatus ".concat(activeClassName)
      }, h("svg", {
        className: "kj-uploader-LoadingStatus__spinner",
        viewBox: "25 25 50 50"
      }, h("circle", {
        className: "kj-uploader-LoadingStatus__spinner-path",
        cx: "50",
        cy: "50",
        r: "20",
        fill: "none",
        stroke: "0072EF",
        strokeWidth: "2"
      })));
    }
  }, {
    key: "install",
    value: function install() {
      this.setPluginState({
        isLoading: false
      });
      var target = this.opts.target;

      if (target) {
        this.mount(target, this);
      }
    }
  }, {
    key: "uninstall",
    value: function uninstall() {
      this.unmount();
    }
  }]);

  return LoadingStatus;
}(UIPlugin);

export { LoadingStatus as default };